import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import Button from "core/buttons/button/Button";
import "./CsltStrToolsForm.scss";
import InputSearchTag from "core/inputs/input-search/InputSearchTag";
import { FILTERS_FOR_NAMES, TAG_TYPES } from "constants/constants";
import { FORM_INFO } from "constants/forms";
import { useContext } from "react";
import InfoContext from "pages/InfoContext";
import PropTypes from "prop-types";
import { formatNamesByFilters } from "components/form/CommonInputs";

function CsltStrToolsForm({
  searchCsltStrTimelineMissions,
  getNamesByFilters,
  namesByFilters,
}) {
  const { csltStrFilter, setCsltStrFilter } = useContext(InfoContext);

  return (
    <div className="cslt-str-tools-wrapper">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="cslt_str_tools"
            defaultMessage="Consultants / sous-traitants"
          />
        }
      />
      <div className="tool-txt">
        <FormattedMessage
          id="desc_cslt_str_tools"
          defaultMessage="Minimum de 3 lettres pour afficher la liste déroulante."
        />
      </div>
      <div className="section-1">
        <div className="cell-padding">
          <InputSearchTag
            errors={{}}
            getOptions={(search) =>
              getNamesByFilters({
                profile: ["str", "cslt"],
                types: [FILTERS_FOR_NAMES.PERSON],
                search,
              })
            }
            label={{
              id: "filter_worker",
              defaultMessage: "Consultants / Sous-traitants",
            }}
            limitChoice={1}
            minLength={2}
            onDelete={(selected) =>
              setCsltStrFilter((old) =>
                old.filter((item) => item.value !== selected)
              )
            }
            options={
              formatNamesByFilters(
                namesByFilters?.filter(
                  (n) =>
                    n?.type === FILTERS_FOR_NAMES.PERSON &&
                    ["cslt", "str"].includes(n?.profile_id)
                )
              ) || []
            }
            popup={FORM_INFO.workerFilter.popup}
            selectedOptions={csltStrFilter}
            setValue={setCsltStrFilter}
            type={TAG_TYPES.CSLT_STR}
            id="worker-filter"
          />
        </div>
      </div>
      <div className="div-buttons">
        <Button
          color="btn-medium gray-700"
          onClick={() => searchCsltStrTimelineMissions()}
          id="button-search"
        >
          <FormattedMessage
            id="search_cslt_str_button_tools"
            defaultMessage="Rechercher le consultant ou sous-traitant"
          />
        </Button>
      </div>
    </div>
  );
}

CsltStrToolsForm.propTypes = {
  searchCsltStrTimelineMissions: PropTypes.func,
  getNamesByFilters: PropTypes.func,
  namesByFilters: PropTypes.array,
};

export default CsltStrToolsForm;
